module.exports = __webpack_public_path__ + "media/2-82.06157052.wav";